<div class="lazy-dropdown-wrapper">
  <ng-select [items]="items$ | async" [loading]="loading" [multiple]="multiple()" [clearable]="clearable()"
    [searchable]="searchable()" [placeholder]="placeholder()" [ngModel]="value"
    (ngModelChange)="onSelectionChange($event)" (open)="onDropdownOpen()" (scroll)="onScroll($event)"
    (search)="onSearch($event.term)" (keydown)="onKeyDown($event)" bindLabel="label" bindValue="id" [virtualScroll]="true" [trackByFn]="trackByFn"
    [hideSelected]="false" [minTermLength]="0" [clearSearchOnAdd]="false" [searchFn]="customSearchFn" appendTo="body">

  <!-- Custom option template when showCustomTemplate is true -->
  @if (showCustomTemplate()) {
    <ng-template ng-option-tmp let-item="item">
      <div class="flex items-center gap-3 py-1">
        <!-- Item Image (if available) -->
        @if (item.image?.url) {
          <div class="flex-shrink-0 w-8 h-8 bg-gray-100 rounded-lg overflow-hidden">
            <img [src]="item.image.url" [alt]="item.label" class="w-full h-full object-cover" loading="lazy" />
          </div>
        } @else {
          <div class="flex-shrink-0 w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center">
            <span class="text-gray-400 text-xs">{{item.label.charAt(0).toUpperCase()}}</span>
          </div>
        }

        <!-- Item Info -->
        <div class="flex-1 min-w-0">
          <div class="text-sm font-medium text-gray-900 truncate">{{ item.label }}</div>
          @if (item.subtitle) {
            <div class="text-xs text-gray-500 truncate">{{ item.subtitle }}</div>
          }
        </div>

        <!-- Item ID -->
        <div class="flex-shrink-0">
          <span class="bg-gray-100 text-gray-600 text-xs font-medium px-2 py-1 rounded">
            ID: {{ item.id }}
          </span>
        </div>
      </div>
    </ng-template>

    <!-- Custom label template for single selected item -->
    <ng-template ng-label-tmp let-item="item">
      <div class="flex items-center gap-2">
        @if (item.image?.url) {
          <img [src]="item.image.url" [alt]="item.label" class="w-5 h-5 rounded object-cover" loading="lazy" />
        }
        <span>{{ item.label }}</span>
      </div>
    </ng-template>
  }

  <!-- Custom multi-label template to prevent collapsing -->
  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
    <div class="custom-multi-label">
      @for (item of items; track item.id) {
        <div class="custom-label-item">
          <span>{{ item.label }}</span>
          <span class="remove-item" (click)="clear(item)">×</span>
        </div>
      }
    </div>
  </ng-template>

  <!-- Loading template for when fetching more items -->
  <ng-template ng-loading>
    <div class="loading-spinner">Loading more...</div>
  </ng-template>

  <!-- No items found template -->
  <ng-template ng-notfound>
    <div class="no-items">No items found</div>
  </ng-template>
</ng-select>

<!-- Hint text -->
@if (hint()) {
  <div class="hint-text" [class.hidden]="!shouldShowHint()">
    {{ hint() }}
  </div>
}
</div>
